import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function Home() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div className="home-page">
      <div className="home-header">
        <div className="user-info">
          <h2>👋 Hey, {user?.displayName || 'Player'}!</h2>
          <p>{user?.email}</p>
        </div>
        <button className="logout-btn" onClick={handleLogout}>
          Logout
        </button>
      </div>

      <div className="action-cards">
        <Link to="/join" className="action-card">
          <div className="icon">🎮</div>
          <h3>Join a Quiz</h3>
          <p>Enter a code to join a live quiz session</p>
        </Link>

        {(user?.userType === 'creator' || user?.userType === 'admin') && (
          <>
            <Link to="/create" className="action-card">
              <div className="icon">✏️</div>
              <h3>Create Quiz Pack</h3>
              <p>Build your own quiz questions</p>
            </Link>

            <Link to="/my-sessions" className="action-card">
              <div className="icon">📊</div>
              <h3>Host a Quiz</h3>
              <p>Start a live quiz session</p>
            </Link>
          </>
        )}

        <Link to="/browse" className="action-card">
          <div className="icon">🔍</div>
          <h3>Browse Quizzes</h3>
          <p>Discover quiz packs from creators</p>
        </Link>

        <Link to="/profile" className="action-card">
          <div className="icon">👤</div>
          <h3>My Profile</h3>
          <p>View stats and achievements</p>
        </Link>
      </div>
    </div>
  );
}

export default Home;
